import { saveEventText, discardEventText, ErrorGeneralMessage } from '../strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';

import { CardMode } from 'txp-data/lib/schema/viewSchema/CardMode';
import { DefaultButton, PrimaryButton, IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { getPalette } from 'owa-theme';

import InfoBar from 'owa-info-bar/lib/components/InfoBar';
import {
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

let style = require('./Txp.scss');

export interface ButtonsEditControlProps {
    onSaveClicked: () => void;
    onDiscardClicked: () => void;
    cardMode: CardMode;
    errorMessage: string;
}

const ButtonsEdit = (props: ButtonsEditControlProps) => {
    const { onSaveClicked, onDiscardClicked, cardMode, errorMessage } = props;
    let clientErrorMessage: string = errorMessage || loc(ErrorGeneralMessage);
    const disableDiscardButton: boolean = cardMode === CardMode.Process;
    const disableSaveButton: boolean = disableDiscardButton || cardMode === CardMode.InvalidInput;
    let palette = getPalette();
    const disabledStyle: IButtonStyles = {
        rootDisabled: {
            color: palette.neutralSecondary,
            backgroundColor: palette.neutralTertiaryAlt,
        },
        root: {
            color: palette.white,
        },
    };

    return (
        <div>
            {cardMode === CardMode.ServerError && (
                <InfoBar
                    className={style.messagebar}
                    textContainerClassName={style.infobarText}
                    messages={[
                        {
                            key: 'editableTxp',
                            source: InfoBarMessageSource.Txp,
                            rank: InfoBarMessageRank.Error,
                            messageParts: [clientErrorMessage],
                        } as InfoBarMessageViewState,
                    ]}
                />
            )}
            <div className={style.editButtonsContainer}>
                <PrimaryButton
                    className={style.saveButton}
                    text={loc(saveEventText)}
                    onClick={onSaveClicked}
                    disabled={disableSaveButton}
                    styles={disabledStyle}
                />
                <DefaultButton
                    className={style.discardButton}
                    text={loc(discardEventText)}
                    onClick={onDiscardClicked}
                    disabled={disableDiscardButton}
                />
                {cardMode == CardMode.Process && (
                    <Spinner className={style.spinner} size={SpinnerSize.small} />
                )}
            </div>
        </div>
    );
};

export default ButtonsEdit;
